import { render, staticRenderFns } from "./RELVeiculosKm.vue?vue&type=template&id=86728dda&"
import script from "./RELVeiculosKm.vue?vue&type=script&lang=js&"
export * from "./RELVeiculosKm.vue?vue&type=script&lang=js&"
import style0 from "./RELVeiculosKm.vue?vue&type=style&index=0&id=86728dda&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports